import Cookies from 'js-cookie';

import { GetLandingBySlugQuery } from '../../../../libs/graphql/betzoneDirectusAPI/queries/__generated__/get-landing-by-slug.query.generated';

type LandingPageData = NonNullable<GetLandingBySlugQuery['Landing']>[0];

/**
 * Captures all query parameters and optionally modifies utm_campaign with promo codes
 */
export const getUtmParams = (
  searchParams: URLSearchParams,
  isComboVariant: boolean,
  landingPageData: LandingPageData,
  promoCodeType?: 'bingo' | 'spins'
): string => {
  const utmParams = new URLSearchParams();
  const promoCode = promoCodeType === 'bingo' ? landingPageData.bingo_promo_code : landingPageData.spins_promo_code;

  // Capture all query parameters
  searchParams.forEach((value, key) => {
    let paramValue = value;

    // Handle utm_campaign modification for pages with promo codes
    if (key === 'utm_campaign' && value && promoCode) {
      paramValue = `${value}-${promoCode}`;
    }

    utmParams.set(key, paramValue);
  });

  if (promoCodeType && !searchParams.has('utm_campaign') && promoCode) {
    const cookieUtmCampaign = Cookies.get('utm_campaign');

    if (cookieUtmCampaign) {
      utmParams.set('utm_campaign', `${cookieUtmCampaign}-${promoCode}`);
    } else {
      utmParams.set('utm_campaign', `-${promoCode}`);
    }
  }

  return utmParams.toString() ? `?${utmParams.toString()}` : '';
};

/**
 * Gets UTM parameters for a specific brand, handling promo codes for all variants
 */
export const getUtmParamsForBrand = (
  searchParams: URLSearchParams,
  isComboVariant: boolean,
  landingPageData: LandingPageData,
  brandType: 'bingo' | 'spins'
): string => {
  return getUtmParams(searchParams, isComboVariant, landingPageData, brandType);
};
